// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export * from "./StorageBrowserPolicyV2-browser.mjs";
